<template>
  <div
    class="MeineStreckenContainer borderGrey"
    :style="{ 'border-bottom-width' : [ anzeigeBisherigeRouten ? '1px' : '0px' ] }"
  >
    <!-- Default Button wenn keine Strecken vorhanden sind -->
    <div
      class="profilOption borderBlue"
      v-if="routen.length === 0"
      @click="$emit('neueRouteAnlegen')"
      :style="{'margin':[kartenansicht ? '30px 0' : '']}"
    >
      <div class="profileOptionTextImage">
        <SVGIcon name="route"/>
        <div class="profilOptionText colorBlue">Strecke anlegen</div>
      </div>
    </div>

    <!-- Wenn Strecken vorhanden sind Button fürs neu anlegen -->
    <div class="content" v-else>
      <div
        class="strecke borderGrey displayflex flexbetween cursor-pointer"
        @click="anzeigeBisherigeRouten = !anzeigeBisherigeRouten"
        :style="{ 'border-bottom-width' : [ anzeigeBisherigeRouten ? '0px' : '1px' ] }"
      >
        <!-- :style="{ 'border-bottom-width' : [ anzeigeBisherigeRouten ? '1px' : '0px' ] }" -->
        <div class="displayflex">
          <SVGIcon name="route_off" class="selfAlignCenter"/>
          <div
            class="streckeText marginleft15 fontweight600 fontsize18 colorBlue"
            style="padding:20px 0;"
          >Meine Strecken</div>
        </div>
        <SVGIcon
          name="icon_expand_more"
          :class="['selfAlignCenter', anzeigeBisherigeRouten ? 'rotate180' :'']"
        />
        <!-- {{'anzeige Bisherige Routen: ' + anzeigeBisherigeRouten}} -->
        <!-- {{routen}} -->
      </div>
      <!-- Bisherige Routen -->
      <div class="streckeContainer marginleft50" v-if="anzeigeBisherigeRouten">
        <div class="strecke borderBlue fontsize16" v-for="strecke in routen" :key="strecke.id">
          <div class="streckeHeader cursor-pointer" @click="toggleStreckeExtended(strecke)">
            <div class="streckeText fontweight600">{{strecke.titel}}</div>
            <div
              class="streckeHeaderDelay selfAlignCenter backgroundYellow"
              v-if="routeStaumeldungen[strecke.id] && routeStaumeldungen[strecke.id].reisezeitverlust !==0"
            >+ {{routeStaumeldungen[strecke.id].reisezeitverlust}} Min</div>
            <SVGIcon
              name="icon_expand_more"
              :class="['selfAlignCenter', strecke.extended ? 'rotate180' :'']"
            />
          </div>

          <div class="streckeContent" v-if="strecke.extended" style="padding-top:10px;">
            <div
              class="colorDarkGrey fontsize16 marginbottom15"
            >{{strecke.start.first_name}} → {{strecke.ziel.first_name}}</div>
            <!--
              ##################################
              Staumeldung falls vorhanden
              ##################################
            -->
            <div v-if="routeStaumeldungen[strecke.id]">
              <div
                v-for="staumeldung in routeStaumeldungen[strecke.id].leafletObj"
                :key="staumeldung._leaflet_id"
              >
                <div
                  v-html="layers[0].icons.popup({props:staumeldung.feature.properties, streettype:getStreetType(staumeldung.feature.properties.street)})"
                ></div>
              </div>
            </div>

            <!-- Buttons -->
            <div class="streckeOptions">
              <!--KameraBilder auf Strecke togglen -->
              <div v-if="anzahlKameras(strecke) !== 0" class="displayflexColumn cursor-pointer" @click="toggleShowWebcams(strecke)">
                <SVGIcon :name="strecke.showWebcams ? 'webcam' : 'webcam_blau'"/>

                <SVGIcon
                  name="icon_expand_more"
                  :class="['selfAlignCenter', strecke.showWebcams ? 'rotate180' :'']"
                />
              </div>
              <!-- Elektrotankstellen -->
              <!-- <div class="displayflexColumn cursor-pointer" @click="toggleShowElektrotankstellen(strecke)">
                <SVGIcon v-if="strecke.showElektrotankstellen" name="e_tankstelle_green" />
                <SVGIcon v-else name="e_tankstelle" />

                <SVGIcon name="icon_expand_more" :class="['selfAlignCenter', strecke.showElektrotankstellen ? 'rotate180' :'']"/>
              </div>-->
              <!-- Route editieren -->
              <SVGIcon
                name="edit_blue"
                class="cursor-pointer"
                @click.native="openEditing(strecke)"
              />
              <SVGIcon
                name="trash_blue"
                class="cursor-pointer"
                @click.native="deleteRoute(strecke)"
              />
              <!-- Route auf Karte als Layer anzeigen -->
              <SVGIcon
                :name="strecke.layerVisible ? 'kartenansicht' : 'kartenansicht_on'"
                class="cursor-pointer"
                @click.native="toggleRoutenLayer(strecke)"
              />
              <!-- setJumpTo(strecke.coordinates) -->
            </div>

            <!--
              ##################################
              Kameras falls vorhanden
              ##################################
            -->
            <div v-if="strecke.showWebcams">
              <!-- Falls keine Kameras vorhanden sind Text anzeigen -->
                <!-- v-if="routeKameras[strecke.id] ? Object.keys(routeKameras[strecke.id]).length === 0 : false" -->
              <div
                v-if="anzahlKameras(strecke) === 0"
                class="paddingtop10"
              >Keine Kameras auf dieser Strecke vorhanden. {{anzahlKameras}}</div>
              <!-- Keine If Bedingung da keine angezeigt werden wenn keine vorhanden sind -->
              <div v-for="kamera in routeKameras[strecke.id]" :key="kamera._leaflet_id">
                <div class="displayflex marginbottom15">
                  <SVGIcon
                    v-if="kamera.feature.properties.filetyp === 'bild'"
                    name="kamera_standbild"
                  />
                  <SVGIcon v-else name="webcam"/>
                  <div
                    class="colorWhite backgroundDarkBlue marginleft15 marginright15 fontweight600 selfAlignCenter"
                    style="padding: 1.5px 10px;"
                  >{{kamera.feature.properties.street}}</div>
                  <div class="selfAlignCenter">{{kamera.feature.properties.title}}</div>
                  <!-- <strong>{{kamera.feature.properties.street}} - {{kamera.feature.properties.title}}</strong> -->
                </div>
                <!-- width='240px' height='160px' -->
                <!-- :src="require(`@/../public/syncdata/kamera/${kamera.feature.properties.id}.jpg`)" -->
                <img
                  v-if="kamera.feature.properties.filetyp === 'bild'"
                  width="100%"
                  height="auto"
                  class="cursor-pointer"
                  alt="kamera"
                  :src="`syncdata/kamera/${kamera.feature.properties.id}.jpg`"
                >
                <!-- width='234px' height='192px' -->
                <!-- require(`@/../public/syncdata/video/${kamera.feature.properties.id}.mp4`) -->
                <video
                  v-else-if="kamera.feature.properties.filetyp === 'video'"
                  width="100%"
                  height="auto"
                  :poster="require('@/assets/images/video-black.png')"
                  preload="none"
                  controls
                >
                  <source
                    :src="`syncdata/video/${kamera.feature.properties.id}.mp4`"
                    type="video/mp4"
                  >Ihr Browser unterstützt die Video Funktion leider nicht.
                </video>
              </div>
            </div>

            <!--
              ##################################
              Elektrotankstellen falls vorhanden
              ##################################
            -->
            <!-- <div v-if="strecke.showElektrotankstellen">
              <div v-if="routeElektrotankstellen[strecke.id] ? Object.keys(routeElektrotankstellen[strecke.id]).length === 0 : false" class="paddingtop10">
                Keine Elektrotankstellen auf dieser Strecke vorhanden.
              </div>
              <div v-for="elektrostankstelle in routeElektrotankstellen[strecke.id]" :key="elektrostankstelle._leaflet_id" style="padding: 10px 0 40px 0;">
                <div v-html="layers[6].icons.popup(elektrostankstelle.feature.properties)"></div>
              </div>
            </div>-->
          </div>
        </div>
      </div>

      <!-- Neu anlegen -->
      <div
        class="profilOption colorBlue borderBlue fontsize16 marginleft50"
        @click="neueRouteAnlegen()"
        style="border:none;padding:10px 0;width:auto;"
        v-if="anzeigeBisherigeRouten"
      >
        <SVGIcon name="plus" size="little"/>
        <div class="profilOptionText">Neue Strecke anlegen</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MeineStrecken",
  data: function() {
    return {
      anzeigeBisherigeRouten: false,
      routeKameras: {},
      routeElektrotankstellen: {}
    };
  },
  methods: {
    deleteRoute(strecke) {
      if (confirm("Möchten Sie diese Route wirklich löschen?")) {
        this.removeRoutenLayer(strecke);
        this.$store.dispatch("deleteRoute", strecke);
      }
    },
    setJumpTo(geometry) {
      this.$store.commit("setJumpTo", { coordinates: geometry });
      this.$emit("closeSidebar");
    },
    openEditing(route) {
      this.$store.dispatch("setEditRoute", route);
      this.$emit("neueRouteAnlegen");
    },
    toggleRoutenLayer(route) {
      const visible = route.layerVisible
      this.$root.$children[0].$refs.map.removeAllRoutenLayer();
      route.layerVisible = !visible;
      this.$store.commit("setRouteLayer", {
        visible: route.layerVisible,
        id: route.id,
        coordinates: route.coordinates
      });
    },
    removeRoutenLayer(route) {
      this.$root.$children[0].$refs.map.removeAllRoutenLayer();
      route.layerVisible = false;
      this.$store.commit("setRouteLayer", {
        visible: route.layerVisible,
        id: route.id,
        coordinates: route.coordinates
      });
    },
    neueRouteAnlegen() {
      this.$store.commit("setRouteLayer", {
        toggleAllOff: true
      });
      this.$emit("neueRouteAnlegen");
    },
    toggleStreckeExtended(strecke) {
      strecke.extended = !strecke.extended;
      if (strecke.extended) {
        this.setRouteKameras(strecke);
        this.resetAllLayer(strecke);
      }
    },
    resetAllLayer(strecke) {
      strecke.showWebcams = false;
      strecke.showStaumeldungen = false;
      strecke.showElektrotankstellen = false;
    },
    toggleShowWebcams(strecke) {
      strecke.showWebcams = !strecke.showWebcams;
      // Vue -> App -> Map
      if (!strecke.showWebcams) return;
      this.setRouteKameras(strecke);
    },
    setRouteKameras(strecke) {
      // Alle Kameras auf der Route abfragen
      this.routeKameras[
        strecke.id
      ] = this.$root.$children[0].$refs.map.checkMarkerOnRoute(
        strecke.coordinates,
        "Verkehrskameras"
      );
    },
    getStreetType(street) {
      if (!street) return;
      const firstLetter = street.split("")[0];
      const streettype =
        firstLetter === "A"
          ? "highway"
          : firstLetter === "B"
          ? "road"
          : firstLetter === "L"
          ? "land"
          : firstLetter === "K"
          ? "kreis"
          : firstLetter === "E"
          ? "empty"
          : "";
      return streettype;
    }
  },
  computed: {
    anzahlKameras() {
      return strecke => {
        if(!this.routeKameras[strecke.id]) return 0;
        return Object.keys(this.routeKameras[strecke.id]).length;
      };
    },
    layerData() {
      const data = this.layers.map(layer => layer.icons.data);
      return data;
    },
    routeStaumeldungen() {
      const layerdata = this.layerData;
      let routeStaumeldungen = {};
      for (const route of this.routen) {
        if (route.coordinates.features[0].geometry.coordinates.length === 0) {
          continue;
        }
        routeStaumeldungen[route.id] = {
          leafletObj: this.$root.$children[0].$refs.map.checkMarkerOnRoute(
            route.coordinates,
            "Verkehrsmeldungen"
          ),
          reisezeitverlust: null,
          staulaenge: null
        };
      }
      for (const streckeID in routeStaumeldungen) {
        let reisezeitverlust = 0;
        let staulaenge = 0;
        for (const leafletID in routeStaumeldungen[streckeID].leafletObj) {
          reisezeitverlust +=
            routeStaumeldungen[streckeID].leafletObj[leafletID].feature
              .properties.reisezeitverlust;

          staulaenge =
            routeStaumeldungen[streckeID].leafletObj[leafletID].feature
              .properties.staulaenge;
        }
        routeStaumeldungen[streckeID].reisezeitverlust = reisezeitverlust;
        routeStaumeldungen[streckeID].staulaenge = staulaenge;
      }
      return routeStaumeldungen;
    },
    layers() {
      return this.$store.state.layers;
    },
    routen() {
      return this.$store.state.routen;
    },
    kartenansicht() {
      return this.$store.state.kartenansicht;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.MeineStreckenContainer {
  height: 100%;
  width: 100%;
  font-size: 18px;
  border-bottom-style: solid;
}

.profilOption {
  border-width: 1px;
  border-style: solid;
  border-radius: 50px;
  padding: 10px;

  margin-bottom: 10px;
  cursor: pointer;
  width: 100%;
  display: flex;
}
.profilOptionText {
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  align-self: center;
}
.profileOptionTextImage {
  display: flex;
  white-space: nowrap;
}

.content {
  width: 100%;
}

.strecke {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  padding: 10px 0;
}
.streckeContainer > .strecke:first-child {
  border-top-width: 1px;
  border-top-style: solid;
}

.streckeHeader,
.streckeOptions,
.streckeIncident {
  display: flex;
  justify-content: space-between;
}
.streckeText {
  display: flex;
  flex-direction: column;
  align-self: center;
}
.streckeHeaderDelay {
  border-radius: 20px;
  padding: 0 10px;
}

.streckeIncident {
  padding: 20px 0;
  justify-content: space-around;
}

.streckeContainer {
  margin-bottom: 10px;
}
</style>
